import fetch from 'isomorphic-fetch';

import { showErrorBar } from 'actions/errorBar';
import {
  endGoogleFetch,
  initGoogleContactInfo,
  startGoogleFetch,
  toggleGoogleInviteSuccess,
} from 'actions/google';
import { ERROR } from 'constants/error-severities';
import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import * as sentry from 'utilities/sentry';

import { GOOGLE } from '../../../shared/constants/oAuthKeys';
import { hasGoogleAppScopes } from '../../../shared/utilities/google';

export function fetchGoogleInfoCreator() {
  return (dispatch, getState) => {
    const {
      is_logged_in: isLoggedIn,
      current: { oauth },
    } = getState().user;

    if (
      !isLoggedIn ||
      !oauth[GOOGLE] ||
      !hasGoogleAppScopes(oauth[GOOGLE].scopes)
    ) {
      dispatch(endGoogleFetch());

      return;
    }

    dispatch(startGoogleFetch());

    return fetch('/v1/users/google', {
      method: 'GET',
      credentials: 'include',
    })
      .then(resp => {
        if (resp.status >= 400) {
          throw new Error(
            `Oops! Error fetching google contact response: ${resp.status}`
          );
        }

        return resp.json();
      })
      .then(respJSON => {
        dispatch(initGoogleContactInfo(respJSON));
        dispatch(endGoogleFetch());

        return respJSON;
      })
      .catch(err => {
        dispatch(endGoogleFetch());

        dispatch(
          showErrorBar(
            ERROR,
            'Oops! There was an error fetching your google contacts'
          )
        );
        sentry.logException(
          err,
          'Exception while fetching google contact info for user'
        );
      });
  };
}

export function postGoogleInviteCreator(info) {
  return dispatch => {
    const {
      invitee_google_id,
      inviter_id,
      invitee_email,
      inviter_first_name,
      invitee_first_name,
    } = info;

    const inviteBody = {
      inviter_id,
      invitee_id: invitee_google_id,
      invite_medium: GOOGLE,
      data: {
        invitee_email,
        invitee_first_name,
        inviter_first_name,
      },
    };

    return fetch('/v1/invite/google', {
      method: 'POST',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body: JSON.stringify(inviteBody),
    })
      .then(response => {
        if (response.status >= 400) {
          throw new Error(`got a bad response status: ${response.status}`);
        }

        dispatch(toggleGoogleInviteSuccess(true));

        return response.json();
      })
      .catch(error => {
        dispatch(
          showErrorBar(
            ERROR,
            'Oops! There was an error sending the invites. Please try again.'
          )
        );
        sentry.logException(error, 'Error in POST to /v1/invite/google');
      });
  };
}
